import router from '@/router'
import axios from 'axios'

const state = {
  authToken: localStorage.getItem('token') || null,
  userId: localStorage.getItem('userId') || null
}

const mutations = {
  authUser (state, userData) {
    state.authToken = userData.token
    state.userId = userData.userId
  },
  clearAuthData (state) {
    state.authToken = null
    state.userId = null
  }
}

const actions = {
  login ({ commit }, { username, password }) {
    let token, userId
    return new Promise((resolve, reject) => {
      axios.post('/auth', { username, password })
        .then(res => {
          token = res.data
          localStorage.setItem('token', token)
          axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
        })
        .then(() => {
          axios.get('/user')
            .then(res => {
              userId = res.data.data.id
              localStorage.setItem('userId', userId)
              commit('authUser', { token, userId })
              resolve()
            })
        })
        .catch((error) => {
          localStorage.removeItem('token')
          localStorage.removeItem('userId')
          reject(error)
        })
    })
  },

  logout ({ commit }) {
    commit('clearAuthData')
    localStorage.removeItem('token')
    localStorage.removeItem('userId')
    delete axios.defaults.headers.common['Authorization']
    router.replace('/login')
  }
}

const getters = {
  isAuthenticated (state) {
    return state.authToken !== null
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
